// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t1sV","title":"styles_title__3pa7t"};